<template>
        <v-toolbar dark color="primary">
          <!-- drop down menu icon -->
                <v-menu
        nudge-bottom="55"
        origin="center center"
        transition="scale-transition"
      >
        <template v-slot:activator="{ on }">
          <v-toolbar-side-icon v-on="on"></v-toolbar-side-icon>
        </template>
  
        <v-list>
          <v-list-tile
            v-for="(item, i) in aqsesori"
            :key="i"
            :to="item.link"
          >
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
          

          <!-- end dropdown -->
      
          <v-toolbar-title class="white--text">წიკლაურის არტ</v-toolbar-title>
      
          <v-spacer></v-spacer>

          <!-- Menu popover info  -->
          <v-menu
          v-model="menu"
        :close-on-content-click="false"
        nudge-left="190"
        nudge-bottom="55"
        transition="slide-x-reverse-transition"
         
      >
        <template v-slot:activator="{ on }">
          <v-btn
            icon            
            v-on="on"
          >
           <v-icon>info</v-icon>
          </v-btn>
        </template>
  
<v-layout row>
      <v-flex offset-x>
        <v-card>
          <v-img
            src="https://graph.facebook.com/100003292396805/picture?type=large&width=220&height=220"
            >
          </v-img>
  
          <v-card-title primary-title>
            <div>
              <div class="headline">გულისა წიკლაური</div>
              <span class="grey--text">ხელნაკეთი ნივთები</span>
            </div>
          </v-card-title>
  
          <v-card-actions>
             <v-spacer></v-spacer>
            <v-btn icon @click="show = !show">
              <v-icon>{{ show ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
            </v-btn>
          </v-card-actions>
  
          <v-slide-y-transition>
            <v-card-text v-show="show">
              <blockquote style="width: 200px">მე ვარ გულისა წიკლაური. ჩემი ჰობია ქარგვა. ჩემს ნამუშევრებს ხშირად ნახავთ სხვადასხვა გამოფენებზე.</blockquote>
              
            </v-card-text>
          </v-slide-y-transition>
        </v-card>
      </v-flex>
    </v-layout>
      </v-menu>
          <!-- end popover -->
        </v-toolbar>
</template>

<script>
export default {
     data: () => ({
            aqsesori: [
                { title: 'ქუდი',
                link: '/qudi' },
                { title: 'სამაჯური',
                    link: '/samajuri'
                },
                { title: 'ჩანთა',
                  link: '/chanta' },
                { title: 'ყელსაბამი' }
                ],
                
            show: false
     })
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Toolbar.vue